// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mIoom","media":"styles_media__y8dQq","text":"styles_text__p9BmF","textFirst":"styles_textFirst__ne_pH"};